import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=cd9ae164&scoped=true&"
import script from "./NormalButton.vue?vue&type=script&lang=js&"
export * from "./NormalButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalButton.vue?vue&type=style&index=0&id=cd9ae164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9ae164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
